import {
  Table,
  TableHead,
  TableHeader,
  TableBody,
  TableRow,
  TableCell,
} from "V2.0/common/table";
import { Button } from "V2.0/common/button";

import { formatTime } from "V2.0/utils";
import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import { Tooltip } from "antd";

export default WebhookTable;

function WebhookTable(props) {
  const { locked, webhooks, onWebhookDelete, onWebhookEdit } = props;

  return (
    <Table>
      <TableHead>
        <TableHeader>Name</TableHeader>
        <TableHeader>URL</TableHeader>
        <TableHeader>Created At</TableHeader>
        <TableHeader>Action</TableHeader>
      </TableHead>
      <TableBody>
        {webhooks.map((webhook) => {
          const handleWebhookDelete = () => onWebhookDelete(webhook);
          const handleWebhookEdit = () => onWebhookEdit(webhook);

          return (
            <TableRow key={webhook._id}>
              <TableCell>{webhook.webhookName}</TableCell>
              <TableCell className="max-w-[200px] truncate">
                <Tooltip
                  placement="topLeft"
                  title={webhook.endpointUrl}
                >
                  {webhook.endpointUrl}
                </Tooltip>
              </TableCell>
              <TableCell>{formatTime(webhook.createdAt)}</TableCell>
              {!locked && (
                <TableCell>
                  <div className="flex items-center gap-x-2">
                    <Button
                      outline
                      onClick={handleWebhookEdit}
                    >
                      <PencilIcon />
                    </Button>
                    <Button
                      outline
                      onClick={handleWebhookDelete}
                    >
                      <TrashIcon />
                    </Button>
                  </div>
                </TableCell>
              )}
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
}
